import { Action, Dispatch } from "redux";
import initialState from "../initialState";
import { NotificationActions } from "./notification/notification-actions";
import { AppDispatch } from "./index";
import { getApi } from "../api/ApiProvider";
import {
  default as StoreModel,
  LoadedResource,
  LoadedSingleResource,
} from "./StoreModel";
import { Client } from "../api/model";

export enum ClientActionTypes {
  FETCH_REQUEST = "[CLIENT][LIST] Request",
  FETCH_RESPONSE = "[CLIENT][LIST] Response",
  FETCH_ERROR = "[CLIENT][ERROR] error",
  SAVE_USER_REQUEST = "[CLIENT][SAVE] Request",
  SAVE_USER_RESPONSE = "[CLIENT][SAVE] Response",
  SAVE_USER_ERROR = "[CLIENT][SAVE] Error",

  SAVE_LOCATION_DEFAULT_REQUEST = "[CLIENT][SAVE] Request",
  SAVE_LOCATION_DEFAULT_RESPONSE = "[CLIENT][SAVE] Response",
  SAVE_LOCATION_DEFAULT_ERROR = "[CLIENT][SAVE] Error",
}

export interface ClientState {
  data: LoadedResource<Client>;
  save: LoadedSingleResource<Client>;
}

export default (
  state: ClientState = initialState.client,
  action?: Action<ClientActionTypes> & { payload: any }
): ClientState => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case ClientActionTypes.FETCH_REQUEST:
      return {
        ...state,
        data: StoreModel.fetching(),
      };

    case ClientActionTypes.FETCH_RESPONSE:
      return {
        ...state,
        data: StoreModel.result(action.payload),
      };

    case ClientActionTypes.FETCH_ERROR:
      return {
        ...state,
        data: StoreModel.error(action.payload),
      };

    case ClientActionTypes.SAVE_USER_REQUEST:
      return {
        ...state,
        save: StoreModel.fetchingSingle(),
      };
    case ClientActionTypes.SAVE_USER_RESPONSE:
      const index = state.data.data.findIndex(
        (el) => el.id === action.payload.id
      );
      if (StoreModel.isLoaded(state.data)) {
        if (index === -1) {
          return {
            ...state,
            data: {
              ...state.data,
              data: state.data.data.concat(action.payload),
            },
            save: StoreModel.resultSingle(action.payload),
          };
        } else {
          const clients = state.data.data;
          const clientsData = [...clients];
          clientsData.splice(index, 1);
          return {
            ...state,
            data: {
              ...state.data,
              data: clientsData.concat(action.payload),
            },
            save: StoreModel.resultSingle(action.payload),
          };
        }
      }
      return {
        ...state,
        save: StoreModel.resultSingle(action.payload),
      };

    case ClientActionTypes.SAVE_USER_ERROR:
      return {
        ...state,
        save: StoreModel.errorSingle(action.payload),
      };

    case ClientActionTypes.SAVE_LOCATION_DEFAULT_REQUEST:
      return {
        ...state,
        save: StoreModel.fetchingSingle(),
      };
    case ClientActionTypes.SAVE_LOCATION_DEFAULT_RESPONSE:
      // if (StoreModel.isLoaded(state.data)) {
      //   return {
      //     ...state,
      //     data: { ...state.data, data: state.data.data.concat(action.payload) },
      //     save: StoreModel.resultSingle(action.payload),
      //   };
      // }
      return {
        ...state,
        save: StoreModel.resultSingle(action.payload),
      };
    case ClientActionTypes.SAVE_LOCATION_DEFAULT_ERROR:
      return {
        ...state,
        save: StoreModel.errorSingle(action.payload),
      };

    default:
      return state;
  }
};

export class ClientActions {
  filter(search: string) {
    return (dispatch: Dispatch) => {
      dispatch({ type: ClientActionTypes.FETCH_REQUEST });
      getApi()
        .client()
        .filter(search)
        .then((data) => {
          dispatch({ type: ClientActionTypes.FETCH_RESPONSE, payload: data });
        })
        .catch((err) => {
          dispatch({ type: ClientActionTypes.FETCH_ERROR, payload: err });
        });
    };
  }

  save(data: {
    id: string;
    name: string;
    document: string;
    email: string;
    phone: string;
    address: string;
  }) {
    return (dispatch: AppDispatch) => {
      const notif = new NotificationActions();

      dispatch({ type: ClientActionTypes.SAVE_USER_REQUEST });

      getApi()
        .client()
        .save(data)
        .then((response) => {
          dispatch(notif.addSuccess("Cliente", "Cliente guardado"));
          dispatch({
            type: ClientActionTypes.SAVE_USER_RESPONSE,
            payload: response,
          });
        })
        .catch((err) => {
          dispatch(
            notif.addError(
              "Cliente",
              "Inconvenientes al guardar, verifique sus datos"
            )
          );
          dispatch({ type: ClientActionTypes.SAVE_USER_ERROR, payload: err });
        });
    };
  }

  updateLocation(data: any) {
    return (dispatch: AppDispatch) => {
      dispatch({ type: ClientActionTypes.SAVE_LOCATION_DEFAULT_REQUEST });

      getApi()
        .client()
        .updateLocation(data)
        .then((response) => {
          console.log("Response update->>", response);

          // dispatch({
          //   type: ClientActionTypes.SAVE_LOCATION_DEFAULT_RESPONSE,
          //   payload: response,
          // });
        })
        .catch((err) => {
          console.log("error update", err);
          dispatch({
            type: ClientActionTypes.SAVE_LOCATION_DEFAULT_ERROR,
            payload: err,
          });
        });
    };
  }

  fetch() {
    return (dispatch: Dispatch) => {
      dispatch({ type: ClientActionTypes.FETCH_REQUEST });
      getApi()
        .client()
        .list()
        .then((data) => {
          dispatch({ type: ClientActionTypes.FETCH_RESPONSE, payload: data });
        })
        .catch((err) => {
          dispatch({ type: ClientActionTypes.FETCH_ERROR, payload: err });
        });
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/client.ts